import { GraphQlOption } from "./types";

export class Global {
    static graphQlOptionValue: GraphQlOption;
}